// extracted by mini-css-extract-plugin
export default {"tooltip":"CustomToolTip_tooltip__0SyCM","link":"CustomToolTip_link__DF-0x","underline-on-hover":"CustomToolTip_underline-on-hover__JmlyU"};